import * as React from "react";
import {memo} from "react";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import {createStyles, Theme} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";
import {fullNamePipe, Teal} from "orpyx-web-common";
import {IGetPatientsListResponse} from "doctors-dashboard/http-clients/index";
import {ORPYX_PORTAL_URL} from "../../../../../../appConstants";

export interface PatientsListNamePortalLinkProps {
    readonly patient: IGetPatientsListResponse;
}

const usePatientsListNamePortalLinkStyle = makeStyles((theme: Theme) => createStyles({
    root: {
        display: 'inline-flex',
        alignItems: 'center',

        color: Teal,
        textDecoration: 'none',

        '&:hover': {
            textDecoration: 'underline',
        },
        '&:focus': {
            outline: `2px solid ${Teal}`,
            outlineOffset: '2px',
        },
    },

    icon: {
        fontSize: '15px',
        marginLeft: '5px',
    },
}));

const portalPatientUrl = (patient: IGetPatientsListResponse): string | undefined => {
    if (!ORPYX_PORTAL_URL || !patient.patientId)
        return undefined;

    return `${ORPYX_PORTAL_URL}/patients/${patient.patientId}`;
};

export const PatientsListNamePortalLink = memo((props: PatientsListNamePortalLinkProps) => {
    const classes = usePatientsListNamePortalLinkStyle();

    const name = fullNamePipe(props.patient);
    const url = portalPatientUrl(props.patient);

    if (!url)
        return <>{name}</>;

    return (
        <a
            className={classes.root}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            title="Open this patient's record in the Orpyx Portal"
            id={`patients-list-name-portal-link-${props.patient.patientId}`}
            onClick={event => event.stopPropagation()}
        >
            {name}
            <OpenInNewIcon className={classes.icon}/>
        </a>
    );
});
